// extracted by mini-css-extract-plugin
module.exports = {"main":"Settings_main__yq3cs","main__contentContainer":"Settings_main__contentContainer__pcqgw","spin":"Settings_spin__1sX48"};